import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginSuccessfulComponent } from './login-successful/login-successful.component';
import { SignupSuccessfulComponent } from './signup-successful/signup-successful.component';

@NgModule({
  declarations: [
    ResetPasswordComponent,
    LoginFormComponent,
    LoginSuccessfulComponent,
    SignupSuccessfulComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    LoginFormComponent,
    ResetPasswordComponent,
    LoginSuccessfulComponent,
    SignupSuccessfulComponent
  ]
})
export class AuthModule { }
